import React, { PureComponent } from "react";
import Api from "../../../../lib/componentApi";
import getAppErrors from "../../../../lib/appErrors";

import SmsVerificationContent from "../../../../components/Users/Profile/SmsVerification";
import AppErrors from "../../../../components/Common/AppErrors";

export default class SmsVerification extends PureComponent {
  state = {
    sms1: "",
    sms2: "",
    sms3: "",
    sms4: "",
    changeNumber: false
  };
  handleChangeInput = e => {
    const { value, id } = e.target;

    this.setState({ [id]: value }, () => {
      if (value.length === 1) {
        if (id === "sms4") {
          document.getElementById(id).blur();
        }
      }
    });
    if (value.length >= 1 && e.target.nextElementSibling) {
      e.target.nextElementSibling.focus();
    }
  };
  handleVerificateSms = event => {
    event.preventDefault();
    const { sms1, sms2, sms3, sms4 } = this.state;
    const { onSmsVerified } = this.props;
    const key = sms1 + sms2 + sms3 + sms4;
    Api.post("/api/set/sms/verification", { key }, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-sms-verification");
        const errorMessage = getAppErrors(response.code);
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message
        });
      } else {
        if (response.status) {
          onSmsVerified();
        }
      }
    });
  };
  onCloseSection = () => {
    const { closeVerification } = this.props;
    closeVerification();
  };
  onClickClose = () => {
    this.setState({
      errorMessage: ""
    });
  };
  onTimeout = () => {
    this.setState({
      errorMessage: "Timeout"
    });
  };
  handleChangeMobileNumber = () => {
    this.setState({
      changeNumber: true
    });
  };
  sendKeyAfterChangedNumber = () => {
    const { sendSmsVerificationKey } = this.props;
    this.setState(
      {
        changeNumber: false
      },
      () => {
        sendSmsVerificationKey();
      }
    );
  };
  render() {
    const { sendSmsVerificationKey, mobileNumber, route } = this.props;
    const { sms1, sms2, sms3, sms4, errorMessage, changeNumber } = this.state;
    return (
      (errorMessage && (
        <AppErrors message={errorMessage} onClickClose={this.onClickClose} />
      )) || (
        <div>
          <SmsVerificationContent
            sms1={sms1}
            sms2={sms2}
            sms3={sms3}
            sms4={sms4}
            route={route}
            handleChangeInput={this.handleChangeInput}
            handleVerificateSms={this.handleVerificateSms}
            onCloseSection={this.onCloseSection}
            sendSmsVerificationKey={sendSmsVerificationKey}
            onTimeout={this.onTimeout}
            mobileNumber={mobileNumber}
            handleChangeMobileNumber={this.handleChangeMobileNumber}
            sendKeyAfterChangedNumber={this.sendKeyAfterChangedNumber}
            changeNumber={changeNumber}
          />
        </div>
      )
    );
  }
}
